var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steps-header",class:_vm.classes,attrs:{"data-ci":"MultiSubBoxDataHeader"}},[_c('div',{staticClass:"steps-header__section"},[(_vm.content)?[_c('span',{staticClass:"line"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.content))]),_vm._v(" "),_c('span',{staticClass:"line"})]:[_c('span',{staticClass:"line"})]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }